import { Trans } from '@lingui/react'
import { bool } from 'prop-types'

import { withI18n } from 'shared/utils/withI18n'
import Modal from 'views/components/molecules/Modal'
import PrescriptionFollowsModalContent from 'views/components/organisms/Checkout/PrescriptionFollowsModalContent'
import { i18nType } from 'views/utils/propTypes'

import { PRESCRIPTION_FOLLOWS_MODAL } from './names'

const PrescriptionFollowsModal = ({
  open,
  i18n,
  withNoPrescriptionFollows,
}) => {
  return (
    <Modal
      size="medium"
      id={PRESCRIPTION_FOLLOWS_MODAL}
      title={i18n._('cart.prescriptionFollows.viaMail')}
      isClientSideControlled
      open={open}
    >
      <h4 className="u-font-weight--bold">
        <Trans id="cart.prescriptionFollows.instructionHeadline" />
      </h4>
      <p className="u-padding-small--bottom">
        <Trans id="cart.prescriptionFollows.prescriptionExplanation" />
      </p>

      <PrescriptionFollowsModalContent
        withNoPrescriptionFollows={withNoPrescriptionFollows}
      />
      <p className="u-padding-small--top">
        <Trans id="cart.prescriptionFollows.prescriptionPleaseSendWithinSevenDays" />
      </p>
    </Modal>
  )
}

PrescriptionFollowsModal.propTypes = {
  open: bool,
  i18n: i18nType.isRequired,
  withNoPrescriptionFollows: bool,
}

PrescriptionFollowsModal.defaultProps = {
  open: false,
  withNoPrescriptionFollows: false,
}

export default withI18n()(PrescriptionFollowsModal)
